<template>
  <!-- マイタスク「派遣先締確認」タブ -->
  <div class="time-sheet-kakute-shime">
    <loading v-if="!isInit"></loading>
    <template v-else>
      <div class="baseinfo">
        <div class="control">
          <div class="search-areas">
            <b>勤務年月／締め日</b>
            <div class="shimebi-selecter flex flex-align-center">
              <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth" :disabled="isLoading"
                :clearable=false></month-picker>
              <input-radio :options="OptionConst.SHIME_DAY_TYPE_OPTIONS" v-model="selectedShimeType"
                @update="updateShimeDayType" :disabled="isLoading"></input-radio>
              <div class="flex flex-align-center" v-if="selectedShimeType === OptionConst.SHIME_DAY_TYPE.SHITEIBI">
                <input-text :type="'number'" @change="changeShimeDay" v-model="shimeDay" inputmode="numeric" class="small"
                  :min="1" :max="31"></input-text>
                <p>日</p>
              </div>
            </div>

            <b>未承認のみ表示</b>
            <input-checkbox :options="OptionConst.NO_LABEL" v-model="isOnlyMiSyounin"></input-checkbox>
    
            <button type="button" class="btn info" @click="searchData" :disabled="isLoading">検索</button>
          </div>
        </div>
      </div>

      <loading v-if="isLoading"></loading>
      <div class="maininfo" v-else>
        <scroll-table v-if="hakenStaffList">
          <table>
            <thead>
              <tr>
                <!-- <th>&nbsp;</th> -->
                <th>名前</th>
                <th>社員番号</th>
                <th>月締承認</th>
                <th>グループ承認者</th>
                <th>就業場所</th>
                <th>締め承認者名</th>
                <th>役職名</th>
                <th>承認日時</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in hakenStaffList" :key="row.user_id"
                v-bind:class="{ 'onlyShimeMisyounin': (isOnlyMiSyounin && (!row.summary || row.summary.syounin_status_type ===  OptionConst.SYOUNIN_STATUS.APPROVED) )  }"
              >
                <!-- <td></td> -->
                <td>{{ row.staff_name }}</td>
                <td>{{ row.staff_code }}</td>

                <!-- <td> -->
                  <!-- icon -->
                  <!-- <div class="icon-container"> -->

                  <template v-if="row.summary">
                    
                    <td>
                      <!-- icon -->
                      <!-- <div class="icon-container"> -->
                      <template v-if="row.summary.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                        <div class=" icon"
                          style="width: 20px;height: 20px;flex-shrink: 0;overflow: hidden;display: flex;justify-content: center;border: 1px solid #b6d8f7; margin: 0 auto;">
                          <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                        </div>
                      </template>

                      <template v-if="row.summary.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                        <div class=" icon"
                          style="width: 20px;height: 20px;flex-shrink: 0;overflow: hidden;display: flex;justify-content: center;border: 1px solid #b6d8f7; margin: 0 auto;">
                          <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                        </div>
                      </template>
                      <!-- </div> -->
                      <!-- icon -->
                    </td>

                    <td>{{ row.syounin_user_name }}</td>
                    <td>{{ row.summary.syuugyou_basyo_name}}</td>
                    <td>{{ row.summary.shime_syounin_user_name }}</td>
                    <td>{{ row.summary.syounin_user_yakusyoku }}</td>
                    <td>{{ dateFormat(row.summary.syounin_datetime) }} {{ timeFormat(row.summary.syounin_datetime) }}</td>
                    <td><button class="btn success" v-on:click="changeHakenList(row)">勤務一覧へ</button></td>
                  </template>
                  <template v-else>
                    <td></td>
                    <td>{{ row.syounin_user_name }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>勤務なし</td>
                  </template>
                
              </tr>
            </tbody>
          </table>
        </scroll-table>
        <p v-else>該当するデータはありません</p>
      </div>
    </template>

  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue';
import { dateFormat, dateFormatJp, dateFormatMMDD, timeFormat } from "@/filters/common";
import { useHakensakiShimeCheckInit } from '@/composable/mytask/soumuhakenshimecheck/init';
import { useHakensakiShimeCheckListInit } from '@/composable/mytask/soumuhakenshimecheck/list';
import { useTimeSheetKakuteiShime } from '@/store/mytask-time-sheet-kakutei-shime';
import OptionConst from "@/const/Option";
import Const from '@/const/Shinsei/Option';
import { MonthPickerModelValue } from "@/components/form/MonthPicker.vue";
import { useRouter } from 'vue-router';
import { RouterConst } from '@/const/Router';
import { useRoute } from "vue-router";
import { useSyuugyouBasyoInit } from '@/composable/syuubyoubasyo/init';
import { useAuthStore } from '@/store/auth';
import { DialogService } from '@/service/DialogService';
import { HakensakiShimeCheckData } from "@/types/MyTask";
import { useMyTaskCommonStore } from '@/store/mytask-common';

export default defineComponent({
  props: ['options', 'tab'],
  setup(props) {

    const isInit = ref(false)

    // 初期化
    const { hakenStaffList, syouninStatus } = useHakensakiShimeCheckInit()

    const { getList } = useHakensakiShimeCheckListInit()
    const { getSyuugyouBasyoListByUserId, syuugyouBasyoList } = useSyuugyouBasyoInit()
    const authStore = useAuthStore()

    const router = useRouter()

    const shimeDay = ref(OptionConst.SHIME_LAST_DAY)
    const selectedShimeType = ref(OptionConst.SHIME_DAY_TYPE.GETSUMATSU)

    const route = useRoute()

    const whereConditonStore = useTimeSheetKakuteiShime()

    // 勤務一覧の年月指定用
    const year = ref(new Date().getFullYear()); // 初期値として現在の西暦をセット
    const month = ref(new Date().getMonth() + 1); // 初期値として現在の月をセット

    const isLoading = ref(false)

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker = computed((): MonthPickerModelValue => {
      return {
        year: year.value,
        month: month.value - 1 // プログラム上の月番号と表示上の月名の補正
      }
    })

    const myTaskCommonStore = useMyTaskCommonStore()

    onMounted(async () => {
      isLoading.value = true
      if (!authStore.user) {
        await DialogService.error({
          title: '',
          html: 'ユーザー情報の取得に失敗しました。<br>お手数をおかけして申し訳ありませんが再度ログインしてください。'
        })
        router.push({ name: RouterConst.LOGIN })
        return
      }
      
      // この画面は派遣先上長が使う想定であり、派遣先上長は雇用契約を更新しない想定なのでshowOldKeiyakuはfalse
      // ※ 派遣先上長（＝派遣先の会社の責任者）はメディカ社員ではないので雇用契約は不要だが、
      // 就業場所IDを持たせないと紐付けられないデータがあるため雇用契約をデータとして持たせている
      // 23.10.3追記 サーバー側で就業場所IDによる絞り込みを行わなくなった（＝必須ではなくなった）ため上記の運用も行わない想定
      await getSyuugyouBasyoListByUserId(authStore.user.user_id)


      // 23.10.3追記 サーバー側で就業場所IDによる絞り込みを行わなくなった（＝必須ではなくなった）ため警告を非表示に変更（ある程度トライアルで問題なければこのブロック消す）
      // 関連：（#rev(MEDICA_AS/client-server-split-column:514d53e16a)）
      // if (syuugyouBasyoList.value.length < 1) {
      //   await DialogService.error({
      //     title: '',
      //     html: '就業場所情報の取得に失敗しました。<br>お手数をおかけして申し訳ありませんがメディカ担当者へご連絡ください。'
      //   })
      //   router.push({ name: RouterConst.HOME })
      //   return
      // }
      // 削除対象ここまで
      
      // 遷移元を取得
      let fromPage = route.params.from ? route.params.from as string : ''
      let cond = whereConditonStore.searchItem
      
      // 年月が保存されていない場合は現在の年月をセット
      let reloadCondition = false
      if (!cond.year) {
        cond.year = year.value
        reloadCondition = true
      }

      if (!cond.month) {
        cond.month = month.value
        reloadCondition = true
      }
      if (!cond.shime) {
        cond.shime = shimeDay.value
        reloadCondition = true
      }

      // 年月の再設定をした場合、条件を取得し直す
      if (reloadCondition) {
        await whereConditonStore.setItem({
          year: cond.year,
          month: cond.month,
          shime: cond.shime
        })
        cond = whereConditonStore.searchItem
        // console.log('検索条件（再読み込み後）', cond)
      }

      // 遷移元が派遣先編集画面で、検索結果が保存されている場合

      // 検索条件を設定
      year.value = cond.year! // 前述の年/月/締め再設定を前提の!指定
      month.value = cond.month! // 前述の年/月/締め再設定を前提の!指定
      shimeDay.value = cond.shime! // 前述の年/月/締め再設定を前提の!指定

      if (shimeDay.value !== OptionConst.SHIME_LAST_DAY) {
        selectedShimeType.value = OptionConst.SHIME_DAY_TYPE.SHITEIBI
      }

      // 送信パラメータ
      await getList({
        year: year.value,
        month: month.value,
        shime: shimeDay.value,
        syuugyouBasyoIds: syuugyouBasyoList.value.map(item => { return item.mst_syuugyou_basyo_id })
      }, hakenStaffList)

      isLoading.value = false
      isInit.value = true
    })

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      month.value = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      year.value = val.year
    };

    // 月締め確定状況の情報を取得します
    const searchData = (async () => {
      isLoading.value = true
      const params = {
        year: yearMonthForMonthPicker.value.year,
        month: yearMonthForMonthPicker.value.month + 1,
        shime: shimeDay.value,
      }

      await whereConditonStore.setItem(params)

      await getList({
        year: year.value,
        month: month.value,
        shime: shimeDay.value,
        syuugyouBasyoIds: syuugyouBasyoList.value.map(item => { return item.mst_syuugyou_basyo_id })
      }, hakenStaffList)

      isLoading.value = false
    })

    // 派遣先リストに切り替え
    const changeHakenList = (async (item: HakensakiShimeCheckData) => {
      // router.push({
      //   name: RouterConst.HAKEN_KINMU_LIST, params: {
      //     kintaiSummaryId: hakenStaffList.value[index].summary?.kintai_summary_id,
      //   }
      // });

      // 現状自動スクロールは実装しないが、する場合は下記が参考になります（24.3.7 大塚）
      // ※ただしscroll-table内での自動スクロールになるので勝手が違う点に要注意
      // src/resources/ts/components/mytask/parts/SoumuDakokuCheck.vue
      // await myTaskCommonStore.setTargetId(item.user_id)
      // 
      // また、ここでsetTargetIdをセットした場合、src/resources/ts/components/kinmu/List.vueのtoSoumuCheckでfromによる分岐が必要なのでその点も注意
      await myTaskCommonStore.setTab('hakensaki-shime-check-list')

      router.push(
        {
          name: RouterConst.KINMU_LIST
          , query: {
            targetUserId: item.user_id,
            targetSyouninGroupId: item.summary?.mst_syounin_group_id,
            from: RouterConst.MY_TASK,
            year: year.value,
            month: month.value
          }
        });
    });

    const updateShimeDayType = (() => {
      if (selectedShimeType.value === OptionConst.SHIME_DAY_TYPE.GETSUMATSU) {
        shimeDay.value = OptionConst.SHIME_LAST_DAY
      } else {
        shimeDay.value = 20 // 月末締めの次に多そうなのが20日締めなので  
      }
    })

    const changeShimeDay = (() => {
      shimeDay.value = Number(shimeDay.value)
    })

    const isOnlyMiSyounin = ref<boolean>(false)

    return {
      isLoading,
      isInit,
      hakenStaffList,
      dateFormat,
      dateFormatJp,
      dateFormatMMDD,
      timeFormat,
      RouterConst,
      syouninStatus,
      yearMonthForMonthPicker,
      changeMonth,
      searchData,
      changeHakenList,
      OptionConst,
      Const,
      shimeDay,
      selectedShimeType,
      updateShimeDayType,
      changeShimeDay,
      isOnlyMiSyounin,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
</style>
